import React from "react";

import './Transaction.css';
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../features/home/userSlice";
import { changeActive, prefillForm } from "../../features/editTransactionForm/editTransactionFormSlice";

export default function Transaction({transaction}) {
    const dispatch = useDispatch();

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;

    let transactionDate = transaction.postedDate ? transaction.postedDate.split("-") : transaction.transactionDate.split("-");
    const month = transactionDate[1];
    const day = transactionDate[2].split('T')[0];
    const year = transactionDate[0];
    
    const handleEditTransactionClick = () => {
        dispatch(changeActive(true));
        dispatch(prefillForm(transaction));
    }

    return (
        <tr>
            <td>{`${month}/${day}/${year}`}</td>
            <td className="description">{transaction.description}</td>
            <td>{transaction.type === 'debit' ? `$${transaction.amount.toFixed(2)}` : ""}</td>
            <td>{transaction.type === 'credit' ? `$${transaction.amount.toFixed(2)}` : ""}</td>
            <td>{transaction.status === 'pending' ? '--' : `$${transaction.accountBalance.toFixed(2)}`}</td>
            {userRole === 'USER' ? "" : <td><button value={transaction.id} onClick={handleEditTransactionClick}>Edit</button></td>}
        </tr>
    )
}